import React, { useEffect, useRef, useState } from 'react'
import { FiBell, FiCalendar, FiLayers } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { ClickAwayListener, Fade, Paper, Popper } from '@material-ui/core'
import { connect, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { PremiumWrapper } from '../../../../../components/Template/Premium'
import { IStore } from '../../../../../reducers'
import { theme } from '../../../../../theme'
import { default as NotificationsList } from '../../../../../containers/Notifications'
import getNotifications from '../../../../../reducers/userAccount/selectors/notifications/getNotifications'
import { getModalUpdateReservationIsOpen } from '../../../../../reducers/bookingCalendar/selectors/getModalOpen'
import { getTaskBadge } from '../../../../../reducers/tasks/selectors'
import { getReservationsListNew } from '../../../../../reducers/reservationsList/selectors'
import { NotificationBadge, NotificationItem } from './Components'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getNotificationsNotReadCount } from '../../../../../reducers/userAccount/selectors/notifications/getNotificationsCounts'
import { getUserId, getUserPriceGroup, isUserNewPremium } from '../../../../../reducers/userAccount/selectors/userAccount'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import { isInPlanScope, PlansScope, useLicensePlansScope } from '../../../Sidebar/Menu'
import {
  isAllInOneLicenseValid,
  isLicenseValid,
} from '../../../../../reducers/userAccount/selectors/license'

function Notifications({
  isAuthorizing,
  taskCount,
  isTemplateModalOpen,
  isReservationModalOpen,
  size = 1,
  notifications,
  eventsFullyLoaded,
  loadEvents,
}) {
  const refMenu = useRef(null)
  const taskBadge = useSelector(getTaskBadge)
  const eventsCount = useSelector(getReservationsListNew).length
  const notificationCount = useSelector(getNotificationsNotReadCount)
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [persistOpen, setPersistOpen] = useState(false)
  const userId = useSelector(getUserId)
  const planScope = useLicensePlansScope()
  const licenseValid = useSelector(isLicenseValid)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const isInUserPlan = isInPlanScope(planScope, PlansScope.Tasks,userPriceGroup)
  const isAllInOnePriceGroup = useSelector(isUserNewPremium)
  const isAllInOneUser = useSelector(isAllInOneLicenseValid)
  const isAllInOneFreeUser = !isAllInOneUser && isAllInOnePriceGroup

  const scopes = useIsScope({
    reservationList: [PermissionScope.SCOPE_CAN_VIEW_LIST_RESERVATIONS],
    tasks: [
      [
        PermissionScope.SCOPE_CAN_USE_TASKS_CLEANING,
        PermissionScope.SCOPE_CAN_USE_TASKS_FOOD,
        PermissionScope.SCOPE_CAN_USE_TASKS_PAYMENTS,
        PermissionScope.SCOPE_CAN_USE_TASKS_INCOMING,
      ],
    ],
  })
  function togglePopper() {
    if (!isOpen) {
      Mixpanel.track('Notifications Menu Item Used', {
        'Number Of Notifications': Number(notificationCount),
      })
      Mixpanel.people.increment(userId, 'Notifications Menu Opened', 1)
    }
    setIsOpen(!isOpen)
    if (Number(taskCount) > 0) setPersistOpen(!isOpen)
  }

  function isCalendarLocation(): boolean {
    return (
      window.location &&
      (window.location.pathname === '/' ||
        window.location.pathname.includes('/booking/calendar'))
    )
  }

  useEffect(() => {
    if (!eventsFullyLoaded && !isCalendarLocation()) {
      //Because of weird calendar events loading
      loadEvents()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function close() {
    if (!isTemplateModalOpen && !isReservationModalOpen) setIsOpen(false)
    if (!isTemplateModalOpen && !isReservationModalOpen) setPersistOpen(false)
  }

  function onClickRes() {
    Mixpanel.track('Reservation List Menu Item Used', {})
    Mixpanel.people.increment(userId, 'Reservations Menu Opened', 1)
    ;(window as any).routerHistory.push('/booking/reservations', {})
  }

  function onClickTask() {
    Mixpanel.people.increment(userId, 'Tasks Menu Opened', 1)
    Mixpanel.track('Tasks Menu Item Used', {
      'Number Of Tasks': Number(taskBadge),
    })
    ;(window as any).routerHistory.push('/tasks', {})
  }

  return (
    <>
      <PremiumWrapper
        size={size}
        style={{ paddingRight: '0' }}
        ref={refMenu}
        alignCenter={true}
        onClick={togglePopper}
        show={Number(taskCount) !== 0 && isOpen}
      >
        {!isAuthorizing && (
          <React.Fragment>
            <Flex
              justifyCenter={true}
              alignCenter={true}
              style={{
                backgroundColor:
                  taskCount === 0 ? 'unset' : theme.colors.palette.kelleyGreen,
                borderRadius: '50%',
                height: `${30 * size}px`,
                pointerEvents: 'none',
                width: `${30 * size}px`,
              }}
            >
              <FiBell size={20 * size} />
            </Flex>
            <div
              style={{
                left: `${-15 * size}px`,
                position: 'relative',
                top: `${-10 * size}px`,
              }}
            >
              <NotificationBadge
                size={size}
                taskCount={taskCount ? String(taskCount) : '0'}
              />
            </div>
          </React.Fragment>
        )}
      </PremiumWrapper>

      <Popper
        anchorEl={refMenu.current}
        open={(Number(taskCount) !== 0 && isOpen) || persistOpen}
        style={{ marginTop: `${-5 * size}px`, zIndex: 50 }}
        popperOptions={{
          positionFixed: true,
        }}
        transition={true}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={150}>
            <ClickAwayListener onClickAway={close}>
              <div
                style={{
                  maxWidth: `${345 * size}px`,
                  minWidth: `${345 * size}px`,
                }}
              >
                <div
                  style={{
                    borderColor: 'transparent transparent white transparent',
                    borderStyle: 'solid',
                    borderWidth: `0 ${10 * size}px ${10 * size}px ${10 *
                      size}px`,
                    height: '0',
                    marginBottom: '0px',
                    marginTop: `${-10 * size}px`,
                    pointerEvents: 'none',
                    position: 'relative',
                    width: '0',
                  }}
                  x-arrow=" "
                />
                <Paper>
                  {planScope && <Flex column={true} full={true}>
                    {scopes.tasks && (
                      <NotificationItem
                        disabled={(!licenseValid || isInUserPlan) && !isAllInOneFreeUser}
                        onClick={(licenseValid && !isInUserPlan) || isAllInOneFreeUser ? onClickTask : undefined}
                        icon={<FiLayers size={16} />}
                        label={t('menu_todolist')}
                        count={String(taskBadge)}
                      />
                    )}
                    {scopes.reservationList && (
                      <NotificationItem
                        disabled={!licenseValid && !isAllInOneFreeUser}
                        onClick={licenseValid || isAllInOneFreeUser ? onClickRes : undefined}
                        icon={<FiCalendar size={16} />}
                        label={t('menu_reservations')}
                        count={String(eventsCount)}
                      />
                    )}

                    {notifications !== 0 && (
                      <NotificationsList size={size} height={'70vh'} />
                    )}
                  </Flex>}
                </Paper>
              </div>
            </ClickAwayListener>
          </Fade>
        )}
      </Popper>
    </>
  )
}

export default connect((state: IStore) => ({
  isReservationModalOpen: getModalUpdateReservationIsOpen(state),
  notifications: getNotifications(state).length,
}))(Notifications)
